import { useMemo } from 'react';

import { Box, DrawerHeader, Flex } from '@chakra-ui/react';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';
import {
  updateMetaData,
  useTemplateMetaDataSelector,
  setEditMode,
} from 'screens/admin/Objectives/GoalPreferences/slice/accessControlSlice';

import { Cross } from 'assets/assetsV1/iconComponents';

import { AutoResizeInput } from 'uiToolkitV1/AutoResizeInput';
import { Button } from 'uiToolkitV1/Button';
import { TextHeader3, TextLabel } from 'uiToolkitV1/Typography';

import TemplateMenu from '../../components/TemplateMenu';

const Header = ({ onClose }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  // const { isOpen, data, isEditMode } = useSelector(accessControlState);

  const { isOpen, type, isEditMode, name, description } = useTemplateMetaDataSelector();

  const onChange = (key, value) => {
    dispatch(updateMetaData({ key, value }));
  };
  const menuOptions = useMemo(() => {
    if (isEditMode) {
      return [
        {
          label: 'View',
          onClick: () => {
            dispatch(setEditMode(false));
          },
        },
      ];
    }
    if (!isEditMode && type !== 'DEFAULT') {
      return [
        {
          label: 'Edit',
          onClick: () => {
            dispatch(setEditMode(true));
          },
        },
      ];
    }
    return [];
  }, [isEditMode, type]);

  return (
    <DrawerHeader pt={3} px={5} pos="relative">
      {isEditMode ? (
        <Flex justifyContent="space-between">
          <Box
            w="100%"
            sx={{
              '.template-name': {
                fontWeight: 'bold !important',
              },
            }}
          >
            <AutoResizeInput
              onChange={(e) => {
                // stopping manual next line
                if (e.target.value.includes('\n')) {
                  e.target.value = e.target.value.replace('\n', '');
                }
                onChange('name', e.target.value);
              }}
              placeholder="Name"
              value={name}
              isDashed
              minW="70%"
              className="template-name"
            />

            <AutoResizeInput
              onChange={(e) => {
                // stopping manual next line
                if (e.target.value.includes('\n')) {
                  e.target.value = e.target.value.replace('\n', '');
                }
                onChange('description', e.target.value);
              }}
              placeholder="Description"
              value={description}
              isDashed
              minW="70%"
            />
          </Box>
          <Box
            marginLeft="auto"
            sx={{
              '.chakra-menu__menu-list': {
                fontSize: '14px !important',
                minWidth: '100px !important',
              },
            }}
          >
            <TemplateMenu usePortal={false} menuOptions={menuOptions} />
          </Box>
        </Flex>
      ) : (
        <Flex justifyContent="space-between">
          <Box flexDirection="column">
            <TextHeader3 color={theme.colors.text.g1} bold>
              {name}
            </TextHeader3>

            <TextLabel>{description}</TextLabel>
          </Box>
          <Box
            sx={{
              '.chakra-menu__menu-list': {
                fontSize: '14px !important',
                minWidth: '100px !important',
              },
            }}
          >
            <TemplateMenu usePortal={false} menuOptions={menuOptions} />
          </Box>
        </Flex>
      )}

      <StyleCloseButton
        variant="filled"
        color="black"
        StartIcon={(props) => <Cross {...props} boxSize="20px" />}
        onClick={onClose}
      />
    </DrawerHeader>
  );
};

const StyleCloseButton = styled(Button)`
  position: absolute;
  left: -14px;
  top: -14px;

  padding: 2px;
  height: 28px;

  border-radius: 50%;
  border: 2px solid ${(props) => props.theme.colors.neutral.F5F7F9};
`;

export default Header;
